namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmKonfiguracniSkupinaProgramovaInstance extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmKonfiguracniSkupinaProgramovaInstanceObj & GContent;
        private isFunkcniMisto: boolean;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmKonfiguracniSkupinaProgramovaInstanceObj());
            this.detailObj.createBase({
                contentName: "detailAdmKonfiguracniSkupinaProgramovaInstance",
                contentCaption: (this.isFunkcniMisto == true) ? "jres:33000609" : "jres:33000368", //RC 33000609 : P�i�azen� instance funk�n�ho m�sta
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.isFunkcniMisto = this.isFunkcniMisto;
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmKonfiguracniSkupinaProgramovaInstance", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            if (this.isFunkcniMisto == true) {
                var rowKonfiguracniSkupina = this.findFormRows("row_ixs_usr");
                rowKonfiguracniSkupina.gformrow("setLabel", "jres:32131054")
            }
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmKonfiguracniSkupinaProgramovaInstanceObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceReadDto> {
        isFunkcniMisto: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["ixs_ins"]
        }

        setSxsDetail(): string {
            return this.data.ixs_usr + "#" + this.data.ixs_ins + "#" + this.data.lic + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmKonfiguracniSkupinaProgramovaInstanceSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmKonfiguracniSkupinaProgramovaInstance.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            if (this.isFunkcniMisto == true) {
                dataObj["ixs_fun"] = dataObj["ixs_usr"];
                delete dataObj["ixs_usr"];
            } else
                dataObj["ixs_fun"] = null;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmKonfiguracniSkupinaProgramovaInstance", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmKonfiguracniSkupinaProgramovaInstance.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1} x {2}".format(this.options.contentCaption, (this.data.ixs_usr_txt) ? this.data.ixs_usr_txt : "", (this.data.ixs_ins_txt) ? this.data.ixs_ins_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            if (this.isFunkcniMisto == true)
                this.MakeSelectField("ixs_usr", Gordic.Prefabs.Select.ginsfun(), { model: "model.ixs_usr=value.ixs_fun" });
            else 
                this.MakeSelectField("ixs_usr", Gordic.Prefabs.Select.ginsusr(), { model: "model.ixs_usr=value.ixs_usr" });
            this.MakeSelectField("ixs_ins", Gordic.Prefabs.Select.ginsins(), { model: "model.ixs_ins=value.ixs_ins", dropdown: false });
            this.MakeSelectField("lic", Gordic.Prefabs.Select.ginslok(), { model: "model.lic=value.lic" });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}